import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { OpcionModel } from '../Global/Opcion.model';
import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';

import * as MandanteNewModel from './Mandante.model';



@Component({
	selector : 'MandanteForm',
	templateUrl : './MandanteNew.component.html'
})


export class MandanteNewComponent  {

	// ~~~~~ Variables para el manejo de permisos ~~~~~ //
	public btnAgregar:boolean;
	public btnEditar:boolean;
	public btnEliminar:boolean;
	public btnConsultar:boolean;
	// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //

	public form:FormGroup;
	public formErrors:any;

	public mandante:MandanteNewModel.MandanteModel;
	public tiposId:Array<OpcionModel>;
	public tiposPersonas:Array<OpcionModel>;
	public tiposContribuyente:Array<OpcionModel>;
	public listaNegocios:Array<OpcionModel>;
	
	
	public ciudades:Array<OpcionModel>;
	public departamentos:Array<OpcionModel>;
	public registroSucursal;
	public principal:boolean;

	
	public registroMandante;
	public mensaje:string;
	public cantidadSucursales;
	public creaSucursal:boolean;

	public ocultar: boolean = false;
	
	


	constructor(private formBuilder:FormBuilder,
		private _serviciosGenerales:ServiciosGenerales, 
		private snackBar: MatSnackBar,
		private _route: ActivatedRoute, 
		private _router:Router){

		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.btnAgregar = _serviciosGenerales.seguridad.isAgregar();
		this.btnEditar = _serviciosGenerales.seguridad.isEditar();
		this.btnEliminar = _serviciosGenerales.seguridad.isEliminar();
		this.btnConsultar = _serviciosGenerales.seguridad.isConsultar();
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

		this.snackBar.dismiss();
		this.formErrors = {
			
			tipoId 	   		  : {},
			numId      		  : {},
			digito        	  : {},
			nombre     		  : {},
			tipoPersona	      : {},
			tipoContribuyente : {},
			sucursal : {},
			direccion : {},
			departamento : {},
			ciudad:{},
			telefono:{},
			correo:{}
		};

		this.tiposId = new Array();
		this.tiposPersonas = new Array();
		this.tiposContribuyente = new Array();
		this.listaNegocios = new Array();


            this.mandante = new MandanteNewModel.MandanteModel(new MandanteNewModel.MchMandatariosId('','','','', 0),
            new MandanteNewModel.DefCiudades(new MandanteNewModel.DefCiudadesId('','',''),''), 
            new  MandanteNewModel.DefTiposdocumentos(''),
            new MandanteNewModel.DefTipospersona(''),'','','','','',0, "", '', '',new MandanteNewModel.DefPrefijos(''),
			new MandanteNewModel.DefTiposIngreso(''));            

		this.principal = false;
		this.ciudades = new Array();
		this.departamentos = new Array();	
	}


	ngOnInit(){

		this.inicializarForm();
		

		this.form.valueChanges.subscribe(() => {
			this.onFormValuesChanged();
		});




		/*Se carga la informacion de las listas*/
		this.cargarInfo();

		/*Se obtiene la informacion que viaja por parametros para cargar el tercero*/
		this._route.params.subscribe( params =>{
			this.registroMandante = [{'cnumcont':params['cnumcont'], 
			'ctipid':params['ctipid'], 
			'cnumid':params['cnumid']}];
		}
		)

		
		
		this.mensaje = "Crear";
		this.mandante.id.cnumcont = this.registroMandante[0].cnumcont;
		this.creaSucursal = true;


	}

	
	inicializarForm(){
		this.form = this.formBuilder.group({			
			
			tipoId 	   : ['', Validators.required],
			numId : ['', Validators.required],
			digito : [{value:0,disabled:true}, Validators.required],
			nombre : ['', this.validarRequerido()],
			tipoPersona : ['', Validators.required],
			tipoContribuyente : ['', Validators.required],
			sucursal : ['', Validators.required],
			direccion : ['', Validators.required],
			departamento : ['', Validators.required],
			ciudad : ['', Validators.required],
			telefono : ['', Validators.required],
			correo : ['', Validators.required]
		});
	}


	validarRequerido(){
		if(this.mandante.defTiposdocumentos.ctipid == '02' || this.mandante.defTiposdocumentos.ctipid == '07' || this.mandante.defTiposdocumentos.ctipid == '08'){
			return null;
		}else{
			return Validators.required;
		}
	}

	cargarInfo(){
		

		this._serviciosGenerales.get('listaNegocios', {param:0}).subscribe(result =>{
			for(let x of result)
				this.listaNegocios.push(new OpcionModel(x.cnumcont, x.cnumcont));
			
		}, 
		error =>{
			var errorMensaje = <any>error;
			console.log('Error al enviar la peticion ', errorMensaje);
			this.openSnackBarEspecial("Ocurrió un error al momento de cargar los patrimonios", "X");

		});

		this._serviciosGenerales.get('tipoIdentificacion', {param:0}).subscribe(result =>{
			for(let x of result)
				this.tiposId.push(new OpcionModel(x.ctipid, x.vdescripcion));
			
		}, 
		error =>{
			var errorMensaje = <any>error;
			console.log('Error al enviar la peticion ', errorMensaje);
			this.openSnackBarEspecial("Ocurrió un error al momento de cargar los tipos de identificación", "X");

		});
		
		this._serviciosGenerales.get('tipoPersona', {param:0}).subscribe(result =>{
			for(let x of result)
				this.tiposPersonas.push(new OpcionModel(x.ntipper, x.vdescripcion));
			console.log(this.tiposPersonas);
			
			this.mandante.defTipospersona.ntipper = "1";
			console.log(this.mandante.defTipospersona.ntipper);
		}, 
		error =>{
			var errorMensaje = <any>error;
			console.log('Error al enviar la peticion ', errorMensaje);
			this.openSnackBarEspecial("Ocurrió un error al momento de cargar los tipos de persona", "X");

		});

		this._serviciosGenerales.get('tiposContribuyente', {param:0}).subscribe(result =>{
			for(let x of result)
				this.tiposContribuyente.push(new OpcionModel(x.nidcontribuyente, x.vdescripcion));
			
		}, 
		error =>{
			var errorMensaje = <any>error;
			console.log('Error al enviar la peticion ', errorMensaje);
			this.openSnackBarEspecial("Ocurrió un error al momento de cargar los tipos de contribuyente", "X");

		});	


		this._serviciosGenerales.get('departamentos', {param:0}).subscribe(
			result =>{
				for(let x of result)
					this.departamentos.push(new OpcionModel(x.ccodigodepto, x.vnombre));
			}, 
			error =>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar los tipos departamentos", "X");
			}
			);


		this._serviciosGenerales.getParametros('TERCEROS', this.mandante);


	}
	



	openSnackBar(message: string, action: string)
	{
		this.snackBar.open(message, action, {
			duration: 20000
		});
	}


	openSnackBarEspecial(message: string, action: string) {
		let snackBarRef =  this.snackBar.open(message, action);

		snackBarRef.onAction().subscribe(() => {
			console.log("Paso por aqui 1 notas");

			this.ocultar = false;
			this.mensaje = "";
		});
		
		let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;		
		
		if (shand.length != 0) {
			    for (let i=0;i<shand.length;i++){
				shand[i].style.backgroundColor = "rgb(255 204 214)";
				}
			}
	}

	onFormValuesChanged()
	{
		for ( const field in this.formErrors )
		{
			if ( !this.formErrors.hasOwnProperty(field) )
			{
				continue;
			}

			// Clear previous errors
			this.formErrors[field] = {};

			// Get the control
			const control = this.form.get(field);

			if ( control && control.dirty && !control.valid )
			{
				this.formErrors[field] = control.errors;
			}
		}
	}


	consultarCiudades(id:number){
        /*
		this.ciudades = new Array();
		this.sucursal.defCiudades.id.ccodigociudad = 0;
		this._serviciosGenerales.get('ciudades', {ccodigodepto:this.sucursal.defCiudades.id.ccodigodepto}).subscribe(
			result =>{
				for(let x of result)
					this.ciudades.push(new OpcionModel(x.ccodigociudad, x.vnombre));
			}, 
			error =>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBar("Ocurrió un error al momento de cargar las ciudades", "X");
			}
            );
            */
	}




	validarTercero(){
        /*
		console.log({ctipid : this.tercero.defTiposdocumentos.ctipid.trim(), cnumid : this.tercero.id.cnumid.trim()});
		this._serviciosGenerales.get('validarTercero', {ctipid : this.tercero.defTiposdocumentos.ctipid.trim(), cnumid : this.tercero.id.cnumid.trim(), cnumcont : this.tercero.id.cnumcont }).subscribe(
			result=>{
				if(result[0].c > 0){
					this.openSnackBar('El tercero : '+this.tercero.defTiposdocumentos.ctipid.trim()+' - '+this.tercero.id.cnumid+' ya existe en el sistema', 'X');
				}
			},error=>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBar("Ocurrió un error al momento de validar el tercero", "X");
            })
            */
	}

	guardar(){
		
	}

	guardarSinValidaciones(){


	}

}


// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/Prefijo/MandanteNew.component.ts